import { AttributesMixin, define } from "@type-r/models";

import { getAuthorizationBearer, getPlatformCode } from "./endpoint";
import { RemittanceAdvice } from "./remittanceAdvice";

export interface RemittanceAdviceEditDTO extends AttributesMixin<typeof RemittanceAdviceEditDTO> { }

@define
export class RemittanceAdviceEditDTO extends RemittanceAdvice {
  
    async update(id: string, data, reload, validationData) {
        const url =  `/api/v1/assetmaster/RemittanceAdvices/assets/${id}`
        const response = await fetch(url, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': getAuthorizationBearer(),
                'X-Platform-Code': getPlatformCode()
            }),
            body: JSON.stringify(data)
        })
        if(response.status == 200 ) {
            validationData.set({})
            reload()
        }

        if(response.status == 400 ) {
            const errorsData = await response.json()
            validationData.set(errorsData.errors)
        }
    }
}